module.exports = __webpack_public_path__ + "img/stripe.a89b50a9.png";